import React from 'react'
import clsx from 'clsx'
import { useStatsJoueursDataContext } from '../../../contexts/StatsJoueursDataContext'
import type { JoueurType } from '../data'
import styles from './styles.module.scss'

const OPTIONS: { label: string; value: JoueurType }[] = [
    {
        label: 'Joueurs de champ',
        value: 'joueur_de_champ',
    },
    {
        label: 'Gardiens de but',
        value: 'gardien',
    },
]

export const JoueurTypeSelector = () => {
    const { joueurType, setJoueurType, setPage } = useStatsJoueursDataContext()

    return (
        <div>
            {OPTIONS.map((x) => {
                const selected = x.value === joueurType
                return (
                    <button
                        key={x.value}
                        onClick={() => {
                            if (selected) return
                            setJoueurType(x.value)
                            setPage(1)
                        }}
                        className={clsx(styles.button, joueurType === x.value && styles.selected)}
                    >
                        {x.label}
                    </button>
                )
            })}
        </div>
    )
}
